/// <reference path="../_references.ts"/>

module App.ItemManagement {
	angular
		.module('itemManagement', [
		])
		.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
			$stateProvider
				.state('zipSolutions.old.itemManagement', {
					url: 'recurring-maintenance',
					redirectTo: 'zipSolutions.maintenance',
				})
				.state('zipSolutions.old.itemDetails', {
					url: 'itemDetails/{itemId:int}',
					redirectTo: 'zipSolutions.maintenance.details',
				})
				.state('zipSolutions.maintenance', {
					url: 'maintenance',
					data: {
						title: 'Recurring Maintenance',
					},
					views: {
						'content@': {
							controller: 'ItemManagementController',
							controllerAs: 'itemMng',
							templateUrl: 'html/item-management/item-management.html',
						},
					},
				})
				.state('zipSolutions.maintenance.details', {
					url: '/{itemId:int}',
					data: {
						title: 'Service Item Details',
					},
					views: {
						'content@': {
							controller: 'ItemDetailsController',
							controllerAs: 'ctrl',
							templateUrl: 'html/item-management/item-details/item-details.html',
						},
					},
				});
		}])
		.service('ItemManagementService', ItemManagementService.Factory())
		.controller('ItemManagementController', ItemManagementController)
		.controller('ItemDetailsController', ItemDetailsController);
}
